import service from '@/store/services/postSeniorRetoucher-service';

const state = {
    doneAdmin: {},
    reDoneAdmin: {},
    reDoneAdminEducation: {}
};

const mutations = {
    SET_DONE_ADMIN: (state, doneAdmin) => {
        state.doneAdmin = doneAdmin;
    },
    SET_RE_DONE_ADMIN: (state, reDoneAdmin) => {
        state.reDoneAdmin = reDoneAdmin;
    },
    SET_RE_DONE_ADMIN_EDUCATION: (state, reDoneAdminEducation) => {
        state.reDoneAdminEducation = reDoneAdminEducation;
    },

};
const actions = {
    doneAdmin({commit, dispatch}, params) {
        return service.doneAdmin(params)
            .then(({doneAdmin}) => {
                commit('SET_DONE_ADMIN', doneAdmin);
            });
    },
    reDoneAdmin({commit, dispatch}, params) {
        return service.reDoneAdmin(params)
            .then(({reDoneAdmin}) => {
                commit('SET_RE_DONE_ADMIN', reDoneAdmin);
            });
    },
    reDoneAdminEducation({commit, dispatch}, params) {
        return service.reDoneAdminEducation(params)
            .then(({reDoneAdminEducation}) => {
                commit('SET_RE_DONE_ADMIN_EDUCATION', reDoneAdminEducation);
            });
    },


};
const getters = {
    doneAdmin: state => state.doneAdmin,
    reDoneAdmin: state => state.reDoneAdmin,
    reDoneAdminEducation: state => state.reDoneAdminEducation,
};

const postSeniorRetoucher = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
export default postSeniorRetoucher;